import { render, staticRenderFns } from "./healthydetail.vue?vue&type=template&id=46f29d40&scoped=true"
import script from "./healthydetail.vue?vue&type=script&lang=js"
export * from "./healthydetail.vue?vue&type=script&lang=js"
import style0 from "./healthydetail.vue?vue&type=style&index=0&id=46f29d40&prod&lang=less&scoped=true"
import style1 from "./healthydetail.vue?vue&type=style&index=1&id=46f29d40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f29d40",
  null
  
)

export default component.exports